{
  "it": {
    "sortGroups": {
      "date": "Data",
      "deadline": "Scadenza",
      "name": "Nome"
    },
    "sorting": {
      "category_name_asc": "Categoria A → Z",
      "category_name_desc": "Categoria Z → A",
      "created_at_asc": "Meno recenti",
      "created_at_desc": "Più recenti",
      "deadline_date_asc": "Scadenza più lontana prima",
      "deadline_date_desc": "Scadenza più vicina prima",
      "due_date asc": "Scadenza più lontana prima",
      "due_date desc": "Scadenza più vicina prima",
      "group_name asc": "Nome A → Z",
      "group_name desc": "Nome Z → A",
      "group_name_asc": "Nome A → Z",
      "group_name_desc": "Nome Z → A",
      "last_name_asc": "Cognome A → Z",
      "last_name_desc": "Cognome Z → A",
      "messaged_all_at_nulls_first_asc": "Meno recenti",
      "messaged_all_at_nulls_last_desc": "Più recenti",
      "messaged_at_nulls_first_asc": "Meno recenti",
      "messaged_at_nulls_last_desc": "Più recenti",
      "name_asc": "Nome A → Z",
      "name_desc": "Nome Z → A",
      "name_lower asc": "Nome A → Z",
      "name_lower desc": "Nome Z → A",
      "name_lower_asc": "Nome A → Z",
      "name_lower_desc": "Nome Z → A",
      "notification_level_name_asc": "Unità A → Z",
      "notification_level_name_asc_sup": "Progetto A → Z",
      "notification_level_name_desc": "Unità Z → A",
      "notification_level_name_desc_sup": "Progetto Z → A",
      "session_started_at_asc": "Sessione iniziata meno di recente",
      "session_started_at_desc": "Sessione iniziata più di recente",
      "status asc": "Stato A → Z",
      "status desc": "Stato Z → A",
      "status_name_asc": "Stato A → Z",
      "status_name_desc": "Stato Z → A",
      "unit_name_asc": "Unità A → Z",
      "unit_name_desc": "Unità Z → A",
      "unit_name_lower_asc": "Unità A → Z",
      "unit_name_lower_desc": "Unità Z → A",
      "updated_at asc": "Aggiornati meno di recente",
      "updated_at desc": "Aggiornati di recente",
      "updated_at_asc": "Aggiornati meno di recente",
      "updated_at_desc": "Aggiornati di recente"
    }
  }
}
